export const language: any = {
  main: "मुख्य",
  ingredients: "सामग्री",
  ai_chef: "एआई शेफ",
  favorites: "पसंदीदा",
  menu: "मेनू",
  get_start: "शुरू करें",
  title_first_1: "एआई उम्र के अनुसार रेसिपी सुझाता है",
  title_second_1: "मेनू से लेकर रेसिपी तक पूरी तरह व्यवस्थित",
  content_1: "दैनिक मेनू और कैलोरी के बारे में चिंता करना बंद करें। अब से, Hey! Cooker से सुझाव प्राप्त करें",
  title_first_2: "आज ठंड है, आपका दिन कठिन रहा।",
  title_second_2: "काम के बाद आर्मी स्टू कैसा रहेगा?",
  content_2: "अपने फ्रिज में रखे डिब्बाबंद मांस और इंस्टेंट नूडल्स ढूंढें और एक साधारण रात का खाना बनाएं!",
  my_food_ingredients: "पता नहीं क्या पकाना है?",
  btn_add_photo: "कोई छवि चुनें या एक फोटो लें",
  my_food_reason: "अपने पास मौजूद सामग्री का चयन करें",
  btn_get_cooking: "एआई रेसिपी सुझाव प्राप्त करें",
  enriching_title: "अपने शरीर और दिमाग को समृद्ध करें",
  enriching: "रेसिपी संग्रह",
  photo_registration_title: "फोटो लें या रसीद अपलोड करें<br/>और मेनू सुझाव प्राप्त करें!",
  photo_registration_content: "सामग्री की पहचान करके और एआई के साथ रेसिपी का विश्लेषण करके खाना पकाने में आनंद जोड़ें!",
  food_suggestions_title: "सोच रहे हैं कि क्या खाना चाहिए?",
  food_suggestions_sub_title: "थीम-आधारित व्यंजन",
  our_interests_title: "अपने और अपने परिवार के लिए सही मेनू बनाएं!",
  our_interests_sub_title: "आयु और लिंग के आधार पर चुनें।",
  favorite_title: "विभिन्न प्रकार की कुकबुक",
  weather_title: "ठंडे मौसम के लिए आदर्श व्यंजन",
  video_title: "रोमांचक वीडियो देखें",
  tag: {
    close: "बंद करें",
    open: "खोलें"
  },
  no_data: "कोई डेटा नहीं",
  update_version_submit: "अभी अपडेट करें",
  update_version_title: "ऐप का नवीनतम संस्करण उपलब्ध है।",
  update_version_content: "इष्टतम उपयोग अनुभव के लिए, कृपया ऐप के नवीनतम संस्करण को अपडेट करें।",
  close_btn: "बंद करें",
  not_video_id: "वीडियो उपलब्ध नहीं है",
  favorite_login: "अपनी पसंदीदा रेसिपी सूची को सहेजने के लिए लॉग इन करें या साइन अप करें।",
  favorite_section_title: "अपनी सहेजी गई रेसिपी की समीक्षा करना न भूलें",
  favorite_section_description: "मेरी पसंदीदा रेसिपी",
  discover: "खोजें",
  my_cooker: "मेरा किचन",
  view_recipe: "चयनित सामग्री से रेसिपी देखें",
  my_ingredient: "मेरी सामग्री",
  add_ingredient: "मेरी सामग्री जोड़ें",
  video_section_title: "वीडियो के माध्यम से खोजें और अनुभव करें",
  video_section_description: "अनुशंसित खाना पकाने के वीडियो",
  age_10: "10 वर्ष से कम",
  age_10_to_20: "10-20 वर्ष",
  age_20_to_30: "20-30 वर्ष",
  age_30_to_40: "30-40 वर्ष",
  age_40_to_50: "40-50 वर्ष",
  age_more_50: "50+ वर्ष",
  suggest_section_title: "Hey! Cooker आपकी पसंद में मदद करेगा",
  suggest_section_description: "आप किन विषयों में रुचि रखते हैं?",
  weather_title1: "आज के सुझाव",
  weather_title2: "बरसात, ठंडे दिन में क्या खाएं?",
  tasteSuggestion1: "अपने स्वाद का आनंद लें",
  tasteSuggestion2: "आपके लिए बनाई गई विशेष स्वाद",
  tasteTitle1: "मसालेदार <br />और लुभावना",
  tasteTitle2: "ताजा और <br />हल्का",
  tasteTitle3: "तीखा <br />और उत्तेजक",
  tasteTitle4: "सुगंधित - <br />मीठा",
  tasteTitle5: "संतुलित और <br />आकर्षक",
  tasteDescription1: "#तलना #भूनना #बरसात का दिन",
  tasteDescription2: "#ताजा #फाइबर #आहार",
  tasteDescription3: "#खट्टा #मीठा #रोमांचक",
  tasteDescription4: "#विशेष #मसाले #जादुई",
  tasteDescription5: "#स्वाद #पोषण #अनुभूति",
  suggest_item_title1: "सरल व्यंजन",
  suggest_item_description1: "सरल नाश्ता और दोपहर के भोजन की रेसिपी",
  suggest_item_title2: "आहार",
  suggest_item_description2: "कम कार्बोहाइड्रेट<br/>बिल्कुल स्वादिष्ट",
  suggest_item_title3: "वर्षांत भोजन",
  suggest_item_description3: "घर की पार्टी के व्यंजन",
  suggest_item_title4: "स्वस्थ भोजन",
  suggest_item_description4: "स्वस्थ शरीर और दिमाग के लिए<br/>बेहतर विकल्प चुनें",
  suggest_item_title5: "सरल स्नैक्स",
  suggest_item_description5: "एकल ड्रिंकिंग स्नैक्स",
  history: "छवि विश्लेषण इतिहास",
  community: {
    sub_title: "सभी के साथ खाना बनाएं",
    title: "Hey! Cooker समुदाय खोजें",
    trending: "ट्रेंडिंग",
    follow: "फॉलो किया गया",
    video: "वीडियो",
    discover: "खोजें",
    no_data: "Hey! Cooker समुदाय से कोई नया अपडेट नहीं",
    discover_post: "समुदाय में अधिक पोस्ट खोजें"
  },
  user_suggest_title1: "आज के सुझाव",
  user_suggest_title2: "यादृच्छिक रेसिपी सुझाव"
}
